import * as ngCore from '@angular/core'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import { StringCase, transformCase } from '@attain-apps/string-utils'

import * as me from '../../../me'
import type { Group } from '../group'

import { Api } from './api'
import type { TypeParams } from './types'

/**
 * Collection of agent chat workspaces
 *
 * @see {@link ec.Collection}
 */
export class Collection extends ec.Collection<TypeParams> {
  constructor(assistantGroup: Group) {
    const api = new Api()
    const meFeature = ngCore.inject(me.Feature)

    super({
      api,
      context$: meFeature.contexts.selectors.zoneContext.asObservable,
      identify: workspace => workspace.id,
      name: ec.Name.Dynamic.from(
        `${transformCase(assistantGroup.id, StringCase.Title)}Workspace`,
      ),
    })
  }
}
